import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { SxProps, Theme } from '@mui/material/styles';
import { FC, useEffect } from 'react';

export interface AuthCallbackProps {
  /** URL to redirect to on success (default: '/') */
  redirectTo?: string;
  /** URL to redirect to on error (default: '/auth/login') */
  errorRedirectTo?: string;
  /** Callback when session is established successfully */
  onSuccess?: (session: { access_token: string; user: { id: string; email?: string } }) => void;
  /** Callback when an error occurs */
  onError?: (error: Error) => void;
  /** Custom styles for the container */
  sx?: SxProps<Theme>;
}

/**
 * Auth callback handler — redirects to login since auth is now API-based.
 * Kept for route compatibility.
 */
export const AuthCallback: FC<AuthCallbackProps> = ({ errorRedirectTo = '/auth/login', sx }) => {
  useEffect(() => {
    // Auth callbacks are no longer handled client-side.
    // Redirect to login page.
    setTimeout(() => {
      window.location.href = errorRedirectTo;
    }, 1500);
  }, [errorRedirectTo]);

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          gap: 3,
          ...sx,
        }}
      >
        <CircularProgress size={48} />
        <Typography variant="h6">Redirecting...</Typography>
      </Box>
    </Container>
  );
};
